module.exports = __webpack_public_path__ + "data-table.bce071e976865da51100.eot";


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/~/@swimlane/ngx-datatable/release/assets/fonts/data-table.eot
// module id = ../../../../@swimlane/ngx-datatable/release/assets/fonts/data-table.eot
// module chunks = 40